import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Homenav from '../homenav'
import { Link } from 'react-router-dom'
import config from '../../variables/config'
import Loading from 'react-spinners/ClipLoader'

import './orders.scss'

export default function index() {
  // order filter can be 'uncompleted' 'completed' or 'all'
  const [orderFilter, setOrderFilter] = useState('uncompleted')
  const [loading, setLoading] = useState(false)
  const [orderData, setOrderData] = useState([])
  const [note, setNote] = useState("")
  const [noteSwitch, setNoteSwitch] = useState(false)
  const [allOrderData, setAllOrderData] = useState([])
  const [page, setPage] = useState(1)
  const [pageLimitReached, setPageLimitReached] = useState(false)
  const [triggerRefetch, setTriggerRefetch] = useState(false)
  const domain = config.serverURL + '/menuOrderBookings'
  const token = JSON.parse(window.localStorage.getItem('userData')).token
  const userDomain = config.serverURL + '/WKUsers'


  useEffect(() => {

    let filteredData
    switch (orderFilter) {
      case 'uncompleted':
        filteredData = allOrderData.filter(item => !item.completed)
        break
      case 'completed':
        filteredData = allOrderData.filter(item => item.completed)
        break
      case 'all':
        filteredData = allOrderData
        break
    }
    setOrderData(filteredData.slice(0, 8 * page))
    if (orderData.length === allOrderData.length) setPageLimitReached(true)
  }, [allOrderData, page, orderData, orderFilter])

  useEffect(() => {
    setTriggerRefetch(false)
    fetchOrderData()
  }, [triggerRefetch])

  async function fetchOrderData() {
    setLoading(true)
    try {
      const response = (await axios.get(`${domain}?token=${token}`)).data
      let newOrderData = [];
      let user = {};
      newOrderData = [...response];

      newOrderData.map(async function(order){
          let id = order.wKUserId;
          try {
            user = (await axios.get(`${userDomain}` + '/'+ id +`?access_token=${token}`)).data
          } catch (err) {
            alert("Couldn't fetch order data from server...")
          }
          order['user'] = user;
      })
      setAllOrderData(newOrderData);

    } catch (err) {
      alert("Couldn't fetch order data from server...")
    }
    setLoading(false)
  }


  async function setCompleted(index) {
    const order = orderData[index]
    setLoading(true)
    try {
      const response = await axios.patch(
        `${domain}/${order.id}?token=${token}`,
        { completed: !order.completed }
      )
      setTriggerRefetch(true)
    } catch (err) {
      alert("Couldn't update completed data in server...")
    }
    setLoading(false)
  }

  async function setPaid(index) {
    const order = orderData[index]
    setLoading(true)
    try {
      const response = await axios.patch(
        `${domain}/${order.id}?token=${token}`,
        { payAtTill: !order.payAtTill }
      )
      setTriggerRefetch(true)
    } catch (err) {
      alert("Couldn't update completed data in server...")
    }
    setLoading(false)
  }

  async function editNote(index) {
    const order = orderData[index]
    setLoading(true)
    try {
      const response = await axios.patch(
        `${domain}/${order.id}?token=${token}`,
        { note: note }
      )
      setTriggerRefetch(true)
      setNoteSwitch(false);
    } catch (err) {
      alert("Couldn't update completed data in server...")
    }
    setLoading(false)
  }

  return (
    <>
      <Homenav />
      <div className="ordersContainer">
        <div className="headerContainer">
          <h1>Table Orders</h1>
          <div className="orderButtons">
            <button
              className={orderFilter === 'uncompleted' ? 'active' : ''}
              onClick={() => setOrderFilter('uncompleted')}>
              Uncompleted orders
            </button>
            <button
              className={orderFilter === 'completed' ? 'active' : ''}
              onClick={() => setOrderFilter('completed')}>
              Completed orders
            </button>
            <button
              className={orderFilter === 'all' ? 'active' : ''}
              onClick={() => setOrderFilter('all')}>
              All orders
            </button>
          </div>
          <button
            className="refreshButton"
            onClick={() => setTriggerRefetch(true)}>
            Refresh{' '}
            <Loading
              loading={loading}
              size={20}
              color="lightBlue"
              css={{ marginLeft: '10px' }}
            />
          </button>
          <Link to="/">
            <button className="backButton">Go Back</button>
          </Link>
        </div>
        <div className="orderList">
          {orderData.map((item, index) => (
            <div
              className={
                item.completed ? 'orderContent completed' : 'orderContent'
              }>
              <li>
                <h3>Table {item.tableNumber} {item.payAtTill ? '' : 'Paid'}</h3>
                {item.items.map(dish => (
                  <div key={dish.name}>
                    <p>
                      {dish.quantity} X {dish.name}
                    </p>
                  </div>
                ))}
                {item.note && <p>{item.note}</p>}
                <p>Time: {item.date.substring(0, 10)} {item.time}   &nbsp;&nbsp;&nbsp; Ordered: {item.orderDate.substring(0, 16)}  &nbsp;&nbsp; &nbsp; Name: {item.user && item.user.firstName} &nbsp; {item.user && item.user.phoneNumber}</p>
              </li>
              <div>
                <button onClick={() => setCompleted(index)}>
                  {item.completed ? 'Mark Uncomplete' : 'Mark Completed'}
                </button>
                <button onClick={() => setPaid(index)}>
                  {item.payAtTill ? 'Mark Paid' : 'Mark Unpaid'}
                </button>
                {noteSwitch ? <textarea value={note} rows="4" cols="50" onChange={e => setNote(e.target.value)} /> : <span></span>}
                {noteSwitch ?
                <button onClick={() => editNote(index)}>
                  {'Save'}
                </button>
                :
                <button onClick={() => {setNoteSwitch(true); setNote(item.note)}}>
                  {'Edit Note'}
                </button>
                }
              </div>
            </div>
          ))}
        </div>
        <button
          className="pageButton"
          onClick={() => setPage(page => page + 1)}>
          {pageLimitReached ? 'No more orders' : 'Load more...'}
        </button>
      </div>
    </>
  )
}
